import React, { useState } from 'react';
import { useCalibracion } from '../../context/FormsProyect/CallibracionContext';
import ImportarCalibracionModal from './ImportarCalibracionModal';

const FrmImportarCalibracion = () => {
    const { saveCalibracionDocument } = useCalibracion();
    const [showImportModal, setShowImportModal] = useState(false);
    const [lastResult, setLastResult] = useState(null);

    const handleConfirmarGuardado = async (items) => {
        const lista = Array.isArray(items) ? items : [{ head: items.head, details: items.details }];
        let successCount = 0;
        let failCount = 0;

        for (const item of lista) {
            const success = await saveCalibracionDocument(item.head, item.details);
            if (success) successCount++;
            else failCount++;
        }

        setLastResult({ success: successCount, fail: failCount, total: lista.length });

        // No need to reload data here as this is just an upload form, 
        // but we could show a "Success" message.
    };

    return (
        <div className="p-8 max-w-4xl mx-auto">
            <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-100 text-center">
                <div className="mb-6 flex justify-center">
                    <div className="bg-indigo-100 p-4 rounded-full">
                        <svg className="w-12 h-12 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" /></svg>
                    </div>
                </div>

                <h2 className="text-2xl font-bold text-gray-800 mb-2">Carga de Documentos de Calibración</h2>
                <p className="text-gray-500 mb-8 max-w-lg mx-auto">
                    Utilice esta opción para cargar archivos Excel de calibración (MasterMeter).
                    Puede seleccionar carga individual o masiva seleccionando múltiples archivos.
                </p>

                <button
                    onClick={() => setShowImportModal(true)}
                    className="px-8 py-3 bg-indigo-600 text-white text-lg font-medium rounded-xl hover:bg-indigo-700 transition-all transform hover:scale-105 shadow-md flex items-center justify-center gap-3 mx-auto"
                >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" /></svg>
                    Iniciar Carga de Archivos
                </button>

                {lastResult && (
                    <div className="mt-8 p-4 bg-gray-50 rounded-lg border border-gray-200">
                        <h4 className="font-semibold text-gray-700 mb-2">Resultado de última operación:</h4>
                        <div className="flex justify-center gap-6 text-sm">
                            <span className="text-gray-600">Total: <b>{lastResult.total}</b></span>
                            <span className="text-green-600">Guardados: <b>{lastResult.success}</b></span>
                            <span className="text-red-600">Fallidos: <b>{lastResult.fail}</b></span>
                        </div>
                    </div>
                )}
            </div>

            <ImportarCalibracionModal
                isOpen={showImportModal}
                onClose={() => setShowImportModal(false)}
                onSave={handleConfirmarGuardado}
            />
        </div>
    );
};

export default FrmImportarCalibracion;
